import { colors } from '../styles/colors';

/**
 * Formatter pour les montants en devise (euros)
 * @param {number} value - Montant à formater
 * @returns {string} Montant formaté en euros
 */
export const formatEuro = (value) => {
  if (value == null || isNaN(value)) return '0 €';
  return new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(value);
};

/**
 * Formatter pour les noms de mois (format court)
 * @param {string} value - Valeur au format "YYYY-MM"
 * @returns {string} Nom du mois en abrégé (Jan, Fév, etc.)
 */
export const formatMois = (value) => {
  if (!value) return '';
  const moisNoms = ['Jan', 'Fév', 'Mar', 'Avr', 'Mai', 'Jun', 'Jul', 'Aoû', 'Sep', 'Oct', 'Nov', 'Déc'];
  const [, mois] = value.split('-');
  return `${moisNoms[parseInt(mois) - 1]}`;
};

/**
 * Composant Tooltip personnalisé pour les graphiques Recharts
 * Affiche les informations au-dessus du point survolé
 * @param {Object} props - Props du tooltip Recharts
 */
export const CustomTooltip = ({ active, payload, label, coordinate }) => {
  if (active && payload && payload.length && coordinate) {
    const tooltipWidth = 180;
    return (
      <div style={{
        position: 'absolute',
        top: coordinate.y,
        left: coordinate.x,
        transform: `translate(-${tooltipWidth / 2}px, -110%)`,
        width: `${tooltipWidth}px`,
        backgroundColor: 'rgba(255, 255, 255, 0.9)',
        border: `1px solid ${colors.secondary.lightGray}`,
        padding: '0.75rem',
        borderRadius: '0.5rem',
        boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
        textAlign: 'center',
        pointerEvents: 'none'
      }}>
        <p style={{
          margin: 0,
          fontWeight: '600',
          color: colors.primary.gray,
          marginBottom: '0.25rem'
        }}>
          {label}
        </p>
        <p style={{ margin: 0, color: colors.primary.teal }}>
          {`${payload[0].name} : ${payload[0].dataKey === 'ca' ? formatEuro(payload[0].value) : `${payload[0].value.toFixed(1)} jours`}`}
        </p>
      </div>
    );
  }
  return null;
};
